import { render, staticRenderFns } from "./ServiceRequestEdit.vue?vue&type=template&id=72afecea&"
import script from "./ServiceRequestEdit.vue?vue&type=script&lang=js&"
export * from "./ServiceRequestEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports